import React, {
	memo,
	useCallback,
	useState
} from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Dropdown
} from 'semantic-ui-react';

import PermissionsWrapper from '../../PermissionsWrapper';

import styles from './actions.module.css';
import HelpModal from '../HelpModal';

const Actions = ( {
	actions = [],
	className
} ) => {
	const [ value, setValue ] = useState( '' );

	const mapActions = useCallback( () => actions.map( action => {
		if ( action.dropdown ) {
			const handleChange = ( e, { value } ) => {
				action.action[ value ]();
				setValue( '' );
			};

			const options = Object.keys( action.action ).map( val => ( {
				key: val,
				text: val,
				value: val
			} ) );

			return (
				<PermissionsWrapper
					key={ action.text }
					permission={ action.permission }
				>
					{ action.helpId
						? <><HelpModal id={ action.helpId } triggerPosition="left" />&nbsp;</>
						: null
					}
					<Dropdown
						button
						className={ `${ styles.button } icon`}
						icon={ action.icon }
						floating
						labeled
						options={ options }
						onChange={ handleChange }
						selectOnBlur={ false }
						selectOnNavigation={ false }
						style={ { fontSize: '0.83333333rem' }}
						text={ action.text }
						value={ value }
					/>
				</PermissionsWrapper>
			);
		}

		return (
			<PermissionsWrapper
				key={ action.text }
				permission={ action.permission }
			>
				{ action.helpId
					? <><HelpModal id={ action.helpId } triggerPosition="left"/>&nbsp;</>
					: null
				}
				<Button
					className={ styles.button }
					content={ action.text }
					disabled={ action.disable }
					icon={ action.icon }
					labelPosition="left"
					onClick={ action.action }
					size="tiny"
				/>
			</PermissionsWrapper> );
	} ), [ actions, value ] );

	return (
		<div className={ `${ styles.actionContainer } no-print ${ className }` } >
			{ mapActions() }
		</div>
	);
};

Actions.propTypes = {
	actions: PropTypes.arrayOf( PropTypes.shape( {
		action: PropTypes.oneOfType( [
			PropTypes.func,
			PropTypes.object
		] ),
		disable: PropTypes.bool,
		dropdown: PropTypes.bool,
		helpId: PropTypes.number,
		icon: PropTypes.string,
		permission: PropTypes.bool.isRequired,
		text: PropTypes.string
	} ) ),
	className: PropTypes.string
};

export default memo( Actions );
